import { Component, Input, input } from '@angular/core';
import { GoogleAnalyticsService } from '../google-analytics.service';

@Component({
  selector: 'help-icon-with-tooltip',
  templateUrl: './help-icon-with-tooltip.component.html',
  styleUrl: './help-icon-with-tooltip.component.css',
  standalone: false,
})
export class HelpIconWithTooltipComponent {
  @Input() tooltipText!: string;
  @Input() isOnlytext?: boolean;
  constructor(private gaService: GoogleAnalyticsService) {}

  onTooltipHover() {
    let tag = '';
    let msg = '';
    if (this.tooltipText.includes('pLDDT score')) {
      tag = 'avrg_plddt';
      msg = 'Hover over Average pLDDT tooltip';
      this.gaService.eventEmitter('tooltip_open','info_tooltip','hover',tag,msg);
    }
    if (this.tooltipText.includes('Overall confidence')) {
      tag = 'domain_quality';
      msg = 'Hovers on Quality tooltip ';
      this.gaService.eventEmitter('tooltip_open','info_tooltip','hover',tag,msg);
    }
    if (this.tooltipText.includes('all segments in the domain')) {
      tag = 'boundaries';
      msg = 'Hovers on Boundries tooltip';
      this.gaService.eventEmitter('tooltip_open','info_tooltip','hover',tag,msg);
    }
    if (this.tooltipText.includes('Total residues')) {
      tag = 'length';
      msg = 'Hovers on Length tooltip';
      this.gaService.eventEmitter('tooltip_open','info_tooltip','hover',tag,msg);
    }
    if (this.tooltipText.includes('residues in the domain')) {
      tag = 'avrg_plddt_domain';
      msg = 'Hovers on Average pLDDT tooltip domains';
      this.gaService.eventEmitter('tooltip_open','info_tooltip','hover',tag,msg);
    }
    
  }
}
